import React from 'react';
import '../template-file-css/document-file-template.css';


export const ACS_CtOrderForServices = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='ACS_CtOrderForServices' className='file-pdf-document'>
            <div className='file-template'>

                <p>
                    <strong>Check One: </strong>&nbsp;&nbsp;
                    <input type="checkbox" id="cbInitialService" name="cbInitialService" className='add-only' value="Initial Service" />
                    Initial Service&nbsp;&nbsp;
                    <input type="checkbox" id="cbReauthorizedService" name="cbReauthorizedService" className='add-only' value="Reauthorized Service" />
                    Reauthorized Service
                </p>
                <h4>Check Appropriate Box for Service Order</h4>
                <table>
                    <tr>
                        <td className='w-25'>&nbsp;</td>
                        <td className='w-425'><span className='eleHeader'>Official Group Name</span></td>
                        <td className='w-300'><span className='eleHeader'>Duration</span></td>
                    </tr>
                    <tr>
                        <td className='w-25'> <input type="checkbox" id="cbOffGrpNm_IFI" name="cbOffGrpNm" className='add-only' value="IFI-Intensive Family Intervention" />
                        </td>
                        <td className='w-425'>IFI-Intensive Family Intervention</td>
                        <td className='w-300'><input type='text' id="txtDuration_1" name="txtDuration_1" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-25'> <input type="checkbox" id="cbOffGrpNm_CommSuppInd" name="cbOffGrpNm" className='add-only' value="Community Support Individual (Children Only)" />
                        </td>
                        <td className='w-425'>Community Support Individual (Children Only)</td>
                        <td className='w-300'><input type='text' id="txtDuration_2" name="txtDuration_2" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-25'> <input type="checkbox" id="cbOffGrpNm_FamilyOutPatient" name="cbOffGrpNm" className='add-only' value="Family Out Patient Services" />
                        </td>
                        <td className='w-425'>Family Out Patient Services</td>
                        <td className='w-300'><input type='text' id="txtDuration_3" name="txtDuration_3" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-25'> <input type="checkbox" id="cbOffGrpNm_CrisisIntervention" name="cbOffGrpNm" className='add-only' value="Crisis Intervention" />
                        </td>
                        <td className='w-425'>Crisis Intervention</td>
                        <td className='w-300'><input type='text' id="txtDuration_4" name="txtDuration_4" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-25'> <input type="checkbox" id="cbOffGrpNm_PsychRehabIndividual" name="cbOffGrpNm" className='add-only' value="Psychosocial Rehabilitation-Individual (Adults Only)" />
                        </td>
                        <td className='w-425'>Psychosocial Rehabilitation-Individual (Adults Only)</td>
                        <td className='w-300'><input type='text' id="txtDuration_5" name="txtDuration_5" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-25'> <input type="checkbox" id="cbOffGrpNm_BehHealthAssmt" name="cbOffGrpNm" className='add-only' value="Beh Health Assmt & Serv Plan Development" />
                        </td>
                        <td className='w-425'>Beh Health Assmt & Serv Plan Development</td>
                        <td className='w-300'><input type='text' id="txtDuration_6" name="txtDuration_6" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-25'> <input type="checkbox" id="cbOffGrpNm_GroupCounseling" name="cbOffGrpNm" className='add-only' value="Group Counseling" />
                        </td>
                        <td className='w-425'>Group Counseling</td>
                        <td className='w-300'><input type='text' id="txtDuration_7" name="txtDuration_7" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-25'> <input type="checkbox" id="cbOffGrpNm_IndOutCounsel" name="cbOffGrpNm" className='add-only' value="Individual Outpatient Counseling" />
                        </td>
                        <td className='w-425'>Individual Outpatient Counseling</td>
                        <td className='w-300'><input type='text' id="txtDuration_8" name="txtDuration_8" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-25'> <input type="checkbox" id="cbOffGrpNm_ADSS" name="cbOffGrpNm" className='add-only' value="Addictive Diseases Support Services" /></td>
                        <td className='w-425'>Addictive Diseases Support Services (Adults)</td>
                        <td className='w-300'><input type='text' id="txtDuration_9" name="txtDuration_9" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-25'> <input type="checkbox" id="cbOffGrpNm_CaseMgmtSrvs" name="cbOffGrpNm" className='add-only' value="Case Management Services" /></td>
                        <td className='w-425'>Case Management Services (Adults)</td>
                        <td className='w-300'><input type='text' id="txtDuration_10" name="txtDuration_10" className='add-only' /></td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='signature w-600'>&nbsp;</td>
                        <td className='signature w-150'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-600'>Therapist Signature (w/credentials)</td>
                        <td className='small w-150'>Date</td>
                    </tr>
                    <tr>
                        <td className='signature w-600'>&nbsp;</td>
                        <td className='signature w-150'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-600'>Therapist Print (w/credentials)</td>
                        <td className='small w-150'>Date</td>
                    </tr>
                </table>








            </div>
        </form>

    )
}    